import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/Card';
import { FormattedDate } from 'react-intl';
import { MaterialIcon } from '@pearsontechnology/aero-components';

import ProjectAvatarStack from '../ProjectAvatarStack';
import ProjectActions from '../ProjectActions';

import {
  ProjectCardContainer,
  ProjectCardHeader,
  ProjectCardHeaderRight,
  ProjectCardFavoriteButton,
  ProjectCardDate,
  ProjectCardContent,
  ProjectCardTitle,
  ProjectAvatarStackWrapper,
} from './styles';

const ProjectCard = ({
  permissionLevel,
  projectId,
  name,
  createdAt,
  onActionsMenuItemClick,
  favoriteIconId,
  favoriteIconClassName,
  onFavoriteClick,
}) => (
  <Card>
    <ProjectCardContainer>
      <ProjectCardHeader>
        <ProjectCardDate>
          <FormattedDate
            value={new Date(createdAt)}
            day="2-digit"
            month="short"
            year="numeric"
          />
        </ProjectCardDate>
        <ProjectCardHeaderRight>
          {favoriteIconId && onFavoriteClick && (
            <ProjectCardFavoriteButton
              type="button"
              aria-label="Favorite"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onFavoriteClick(e);
              }}
            >
              <MaterialIcon id={favoriteIconId} className={favoriteIconClassName} />
            </ProjectCardFavoriteButton>
          )}
          <ProjectActions projectId={projectId} permissionLevel={permissionLevel} onActionsMenuItemClick={onActionsMenuItemClick} isGrey />
        </ProjectCardHeaderRight>
      </ProjectCardHeader>
      <ProjectCardContent>
        <ProjectCardTitle>
          {name}
        </ProjectCardTitle>
        <ProjectAvatarStackWrapper>
          <ProjectAvatarStack projectId={projectId} hideButton />
        </ProjectAvatarStackWrapper>
      </ProjectCardContent>
    </ProjectCardContainer>
  </Card>
);

ProjectCard.propTypes = {
  permissionLevel: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  name: PropTypes.string,
  createdAt: PropTypes.string,
  onActionsMenuItemClick: PropTypes.func,
  /** When set with `onFavoriteClick`, shows a Material icon (e.g. `push_pin` with `favoriteIconClassName`). */
  favoriteIconId: PropTypes.string,
  /** e.g. `material-icons` (filled) vs `material-icons-outlined` for the same ligature. */
  favoriteIconClassName: PropTypes.string,
  onFavoriteClick: PropTypes.func,
};

ProjectCard.defaultProps = {
  handleMenuClick: () => {},
  favoriteIconId: undefined,
  favoriteIconClassName: undefined,
  onFavoriteClick: undefined,
};

export default ProjectCard;
